export default "__VITE_ASSET__DeAnhMFY__"